export const SET_SUPPLIER_HAS_DISCOUNTS = "SET_SUPPLIER_HAS_DISCOUNTS";

export const setSupplierHasDiscounts = (hasDiscounts) => {
  return {
    type: SET_SUPPLIER_HAS_DISCOUNTS,
    payload: {
      hasDiscounts,
    },
  };
};
